export default {"src":"/_next/static/media/folder.dede6584.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};